<template>
  <div class="PuriContentDeleteFinish">
    <section-header>画像削除完了</section-header>
    <div class="description">
      {{ description }}
    </div>
    <div class="album-button">
      <normal-btn @click="onAlbum">アルバム一覧ページへ戻る</normal-btn>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '../components/NormalBtn.vue'

export default {
  name: "PuriContentDeleteFinish",
  components: {
    SectionHeader,
    NormalBtn
  },
  data() {
    return {
      description: '画像を削除しました。'
    }
  },
  methods: {
    onAlbum() {
      this.$router.push('/album')
    }
  }
}
</script>

<style scoped>
.description {
  color: #5e5e5e;
  font-size: 12px;
  margin: 40px 20px;
  max-width: calc(100% - 40px);
  text-align: center;
  white-space: pre-wrap;
}
.album-button {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
